module.exports = __webpack_public_path__ + "media/images/landing/browser_perspective.es-949217fd07977376b321ff08b056544b.png";